import { render, staticRenderFns } from "./ExternalProduct.vue?vue&type=template&id=037ed43a&"
import script from "./ExternalProduct.vue?vue&type=script&lang=js&"
export * from "./ExternalProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports